import { render } from "./Help-center-page.vue?vue&type=template&id=b26016da&scoped=true"
import script from "./Help-center-page.vue?vue&type=script&lang=js"
export * from "./Help-center-page.vue?vue&type=script&lang=js"

import "./Help-center-page.vue?vue&type=style&index=0&id=b26016da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26016da"]])

export default __exports__